// Page copy for the redesigned Studio. Keep enUS and zhCN structurally identical.
export const enUS = {
  notFound: {
    title: 'Page not found',
    body: 'This address does not point to a Studio page.',
    action: 'Go to Home',
  },
}

export const zhCN = {
  notFound: {
    title: '页面不存在',
    body: '这个地址没有对应的 Studio 页面。',
    action: '回到首页',
  },
}
